<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.attrName"
          placeholder="请输入事件显示名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="paging(1)"
          >查询</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="id"
          label="事件名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="attrName"
          label="事件显示名"
        >
        </el-table-column>
        <el-table-column width="140px" header-align="center" align="center">
          <template slot="header">
            <el-popover placement="top-start" width="200" trigger="hover">
              <div class="content">
                <div>有效: 该埋点事件最近2天有收到过日志上报</div>
                <div>
                  无效:该埋点事件最近2天从未收到过日志上报
                </div>
              </div>
              <div slot="reference">
                <span>是否有数据上报</span>
                <span class="question-mark">?</span>
              </div>
            </el-popover>
          </template>
          <template v-slot="scope">
            <span v-if="scope.row.validateInfo === '有效'" class="success"
              >有效</span
            >
            <span v-else class="danger">最近2天未收到数据</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="attrNum"
          label="属性数量"
        ></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="platform"
          label="埋点平台"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="140px"
          prop="lastCollectionTime"
          label="上次修改时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createBy"
          label="创建人员"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <!-- <el-button size="small" type="text" @click="viewState(scope.row)"
                >回数状态</el-button
              > -->
              <el-button size="small" type="text" @click="toDetails(scope.row)"
                >上报监控</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div> -->
    </div>
    <el-dialog
      title="回数状态"
      :close-on-click-modal="false"
      @close="dialogVisible = false"
      :visible.sync="dialogVisible"
    >
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="attrName"
          label="属性名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="remark"
          label="属性中文名"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="数据类型">
          <template v-slot="scope">
            <span v-if="scope.row.validateInfo === '有效'" class="success"
              >有效</span
            >
            <span v-else class="danger">最近2天未收到数据</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="remark"
          label="最后上报时间"
        >
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitReject('ruleForm')" size="small" type="primary"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      platform: "",
      validateInfo: "",
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      dialogVisible: false,
      ruleForm: {
        attrName: "",
        remark: "",
        status: false
      },
      rules: {
        attrName: {
          required: true,
          message: "请输入营销原因",
          trigger: "change"
        },
        status: {
          required: true
        }
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async queryList() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      const { result } = await this.$store.dispatch("queryTrackList", {
        // pageNo: this.currentPage,
        // pageSize: this.pageSize,
        attrName: searchCondition.attrName || undefined
      });
      // const { records, total } = result;
      this.list = result;

      // this.list = records;
      // this.total = total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async viewState(row) {
      this.dialogVisible = true;
      const { result } = await this.$store.dispatch("queryLoopStatus", {
        id: row.id
      });
    },
    toDetails(row) {
      this.$router.push({
        name: "ReportAndMonitor",
        query: {
          id: row.id,
          eventName: row.remark
        }
      });
    },
    submitReject() {
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.question-mark {
  display: inline-block;
  margin-left: 5px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  line-height: 18px;
  text-align: center;
  background: #ddd;
  color: #fff;
}
</style>
